import { render, staticRenderFns } from "./SidebarGroup.vue?vue&type=template&id=ca0d7882&scoped=true"
import script from "./SidebarGroup.vue?vue&type=script&lang=js"
export * from "./SidebarGroup.vue?vue&type=script&lang=js"
import style0 from "./SidebarGroup.vue?vue&type=style&index=0&id=ca0d7882&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0d7882",
  null
  
)

export default component.exports